import React from 'react'
import FirestoreService from '../../../../services/firestoreService'

import { IRegisteredUser } from '../../../../types/entryRider'
import { IRegistrationByDayInterface } from '../../../../models/registrations-by-day/registrationByDay.interface'

import { CONST } from '../../../../const/const'

interface IProps {
  backNumber: number
  id: string
  cbUpdate: (value: number) => void
  allRiders: IRegisteredUser[]
  registrationsByDay: IRegistrationByDayInterface[]
}
export const BackNumber: React.FC<IProps> = ({
  backNumber,
  id,
  cbUpdate,
  allRiders,
  registrationsByDay,
}) => {
  const [back, setBack] = React.useState(0)
  const [editMode, setEditMode] = React.useState(false)
  const divRef = React.useRef<HTMLDivElement | null>(null)
  const [isExist, setIsExist] = React.useState(false)
  const updateNumberHandler = React.useCallback(async () => {
    const riderIndex = allRiders.findIndex((r) => r.id === id)
    if (!allRiders[riderIndex]) {
      return null
    }

    const promises: Promise<void>[] = []

    registrationsByDay.forEach((rider) => {
      if (
        rider.riderId === allRiders[riderIndex].riderId &&
        rider.registrationDocId === allRiders[riderIndex].registrationDocId &&
        rider.horseId === allRiders[riderIndex].horseId
      ) {
        promises.push(
          FirestoreService.updateItem(
            CONST.DATA.FIRESTORE.V01.COLLECTIONS.REGISTRATION_BY_DAY.NAME,
            rider.id,
            {
              backNumber: +back,
            }
          )
        )
      }
    })

    setEditMode(false)
    if (backNumber === back) {
      return null
    }
    const hasBackNumber = allRiders.some((obj) => +obj.backNumber === +back)
    if (hasBackNumber) {
      setIsExist(true)
      return null
    }

    try {
      await Promise.all(promises)
      cbUpdate(back)
    } catch (error) {
      console.error('error', error)
    }
  }, [allRiders, backNumber, back, id, cbUpdate])

  const handleClickOutside = React.useCallback(
    async (event: any) => {
      if (editMode && divRef.current && !divRef.current.contains(event.target)) {
        updateNumberHandler().then(() => null)
      }
    },
    [editMode, divRef, updateNumberHandler]
  )

  React.useEffect(() => {
    setBack(backNumber)
  }, [backNumber])

  React.useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [handleClickOutside])

  const onChangeHandler = async (value: string) => {
    const regex = /^[0-9\b]+$/

    if (value === '' || regex.test(value)) {
      setBack(+value || 0)
    }
  }

  return (
    <div ref={divRef} className='flex items-center w-full'>
      <span className="md:hidden">Back #</span>
      {editMode ? (
        <input
          className={`w-[100%] outline-none rounded-sm border-[#D3DAEE] focus:border-[#D3DAEE]`}
          onChange={(e) => onChangeHandler(e.target.value)}
          value={back}
          type="text"
          onKeyDown={async (event) => {
            if (event.key === 'Enter') {
              updateNumberHandler().then(() => null)
            }
          }}
        />
      ) : (
        <span
          onClick={() => {
            setEditMode(true)
          }}
          className={` whitespace-nowrap cursor-pointer block text-center w-[40px] text-[16px] ${isExist ? 'text-SeabiscuitMainThemeColor font-normal' : back !== 0 ? 'text-SeabiscuitDark200ThemeColor font-normal' : 'text-SeabiscuitDark200ThemeColor/40 font-normal '}`}
        >
          {back}
          {isExist && <span className={'block text-[10px] font-light'}>Taken</span>}
        </span>
      )}
    </div>
  )
}
